<template>
  <div class="menu">
    <div class="content">
      <div class="left">
        <div class="course">
          <div class="top">
            <img src="https://img2.233.com/wx/union/pure/pc/nve_icon.png" alt="menu" />
            <i></i>
            <h2>{{ mainConfig.ClassCName }}</h2>
          </div>
          <div class="hover" v-if="mainConfig.CategoryChildClassList && mainConfig.CategoryChildClassList.length > 0">
            <router-link v-for="item in mainConfig.CategoryChildClassList" :key="item.ClassEName" :class="item.ClassEName === curClass ? 'select' : ''" :to="{ path: '/', query: { class: item.ClassEName } }">{{ item.ClassCName }}</router-link>
          </div>
        </div>
        <div class="address" v-if="mainConfig.CategoryCourseAreaList && mainConfig.CategoryCourseAreaList.length > 0">
          <div class="top" v-if="mainConfig.CategoryCourseAreaList.find((item) => curArea === item.AreaEName)">
            <i :class="skinColor"></i>
            <span>
              {{ mainConfig.CategoryCourseAreaList.find((item) => curArea === item.AreaEName).AreaCName }}
            </span>
          </div>
          <div class="hover">
            <div class="box">
              <span v-for="item in mainConfig.CategoryCourseAreaList" :key="item.AreaEName" :class="item.AreaEName === curArea ? 'select' : ''" @click="changeArea(item.AreaEName)">
                {{ item.AreaCName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <ul>
          <li @click="$emit('openLink', 1)">选课中心</li>
          <li @click="$emit('openLink', 2)">我的课程</li>
          <li>
            <span>免费题库</span>
            <span @click="$emit('openLink', 3)">章节练习</span>
            <span @click="$emit('openLink', 4)">考前点题</span>
            <span @click="$emit('openLink', 5)">历年真题</span>
            <span @click="$emit('openLink', 6)">模拟考场</span>
            <span @click="$emit('openLink', 7)">每日一练</span>
            <span @click="$emit('openLink', 8)">易错题</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  props: {
    curClass: {
      type: String,
      default: ""
    },
    curArea: {
      type: String,
      default: ""
    },
    areaList: {
      type: Array,
      default: () => []
    },
    mainConfig: {
      type: Object,
      default: () => {}
    },
    skinColor: {
      type: String,
      default: ""
    }
  },
  methods: {
    changeArea(area) {
      const { href, pathname } = window.location;
      const _class = href.slice(href.indexOf("class") + 6, href.length).split("&")[0];
      if (href.indexOf("class")) {
        window.location.href = window.location.origin + pathname + "#/?class=" + _class + "&area=" + area;
      } else {
        window.location.href = window.location.origin + pathname + "#/?area=" + area;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
.menu {
  background: white;
  .content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 60px;
    .left {
      display: flex;
      align-items: center;
      height: 60px;
      .course {
        position: relative;
        &:hover .hover {
          display: inline-block;
        }
        .top {
          @include menu_background();
          display: flex;
          align-items: center;
          height: 60px;
          cursor: pointer;
          padding-right: 24px;
          box-sizing: border-box;
          min-width: 225px;
          img {
            width: 22px;
            height: 12px;
            margin-left: 22px;
          }
          i {
            width: 1px;
            height: 36px;
            @include menu_background_vertical();
            margin: 0 24px;
          }
          h2 {
            display: inline-block;
            color: #fff;
            font-size: 19px;
            font-weight: 400;
          }
        }
        .hover {
          position: absolute;
          top: 60px;
          left: 0;
          width: 484px;
          background: #ffffff;
          box-shadow: 1px 15px 60px 3px rgba(0, 0, 0, 0.39);
          display: none;
          z-index: 1;
          a {
            display: inline-block;
            line-height: 22px;
            width: 160px;
            padding: 18px 0;
            text-align: center;
            color: #565656;
            font-size: 16px;
            font-weight: 400;
            border-bottom: 1px solid #f1f3f4;
            cursor: pointer;
            text-decoration: none;
            &:nth-child(3n-2),
            &:nth-child(3n-1) {
              border-right: 1px solid #f1f3f4;
            }
            // &:nth-last-child(1), &:nth-last-child(2), &:nth-last-child(3){
            //   border-bottom: none;
            // }
            &:hover {
              @include menu_select_class();
            }
          }
          .select {
            @include menu_select_class();
          }
        }
      }
      .address {
        margin-left: 24px;
        position: relative;
        cursor: pointer;
        &:hover {
          .top {
            @include menu_address_border();
            .red {
              background: url(https://img2.233.com/wx/union/pure/pc/red/nve_zb_ic_hover.png) no-repeat center center;
            }
            .green {
              background: url(https://img2.233.com/wx/union/pure/pc/green/nve_zb_ic_hover.png) no-repeat center center;
            }
            .blue {
              background: url(https://img2.233.com/wx/union/pure/pc/blue/nve_zb_ic_hover.png) no-repeat center center;
            }
            span {
              @include menu_address_color();
            }
          }
          .hover {
            display: inline-block;
          }
        }
        .top {
          display: inline-block;
          height: 28px;
          line-height: 26px;
          border: 1px solid #6b6b6b;
          padding: 0 11px;
          border-radius: 14px;
          i {
            display: inline-block;
            width: 9px;
            height: 14px;
            margin-right: 5px;
            vertical-align: middle;
            background: url(https://img2.233.com/wx/union/pure/pc/nve_zb_ic.png) no-repeat center center;
          }
          span {
            color: #343434;
            font-size: 15px;
            font-weight: 400;
          }
        }
        .hover {
          position: absolute;
          top: 30px;
          left: 0;
          padding: 7px 0;
          display: none;
          .box {
            width: 441px;
            background: #fff;
            box-shadow: 1px 10px 27px 1px rgba(0, 0, 0, 0.46);
            border-radius: 10px;
            padding: 10px 20px;
            span {
              display: inline-block;
              color: #565656;
              font-size: 15px;
              font-weight: 400;
              padding: 0 10px;
              margin: 4px 0;
              height: 25px;
              line-height: 25px;
              border-radius: 13px;
              cursor: pointer;
              &:hover {
                @include menu_address_background();
                color: white;
              }
            }
            .select {
              @include menu_address_background();
              color: white;
            }
          }
        }
      }
    }
    .right {
      ul {
        display: flex;
        li {
          list-style: none;
          line-height: 60px;
          color: #343434;
          font-size: 17px;
          font-weight: 400;
          width: 136px;
          height: 60px;
          text-align: center;
          transition: all 0.3s;
          cursor: pointer;
          z-index: 666;
          &:nth-child(1),
          &:nth-child(2) {
            &:hover {
              @include globe_hover_color();
            }
          }
          span {
            display: none;
            color: #565656;
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;
            padding: 10px 0;
            width: 136px;
            transition: all 0.3s;
            cursor: pointer;
            &:hover {
              @include globe_hover_color();
            }
            &:nth-child(1) {
              font-size: 17px;
              display: inline-block;
              line-height: 60px;
              padding: 0;
            }
          }
          &:nth-last-child(1) {
            line-height: 20px;
            &:hover {
              background: #ffffff;
              box-shadow: -1px 9px 24px 1px rgba(0, 0, 0, 0.11);
              @include menu_address_border_top();
              height: 300px;
              span {
                display: inline-block;
                &:nth-child(1) {
                  color: #343434;
                  font-weight: Bold;
                }
                &:nth-child(2) {
                  padding-top: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
